<template>
  <div id="box" v-if="productFlag!=4">
    <div v-if="isShowCenter" class="course_content">
      <div class="menu-toggle" :class="{ 'menu-open': !menuFlag }" @click="toggleMenu"></div>
      <div class="course_left" v-if="menuFlag">
        <div class="study_progress">
          <div class="study_task_statistics">
            <p>课程预览</p>
          </div>
        </div>
        <div class="course_tree" :style="'height:'+treeHeight">
          <el-tree
            :data="data"
            :props="defaultProps"
            node-key="id"
            :default-expanded-keys=expendId
            :highlight-current="true"
            @node-click="handleNodeClick"
            ref="vuetree"
          >
           <span class="span-ellipsis" slot-scope="{ data, node }">
              <span :title="node.label">{{ node.label }}</span>
              <span v-if="data.lockStatus==1" class="is_finish"><i class='el-icon-lock'></i></span>
            </span>
          </el-tree>
        </div>
      </div>
      <div v-if="!statusLoading" class="course_main_wrap">
        <div class="course_main" v-loading="loading">
          <miniSwiper v-if="!swiperFlag" :sign="'preview'"></miniSwiper>
          <div v-show="showMain" v-if="!(listItem=== null)" class="show_main">
            <h2 class="title">
              <span v-if="listItem.testPaper === null">{{listItem.resourceType === 3 ? "试题" : listItem.name}}</span>
              <span v-else>{{listItem.resourceType === 3 ? "试题" : listItem.name+"("+listItem.testPaper.paperScore+"分"+"/"+listItem.testPaper.count+"题"+")"}}</span>
              <button v-if="listItem.downloadFlag==1&&listItem.resourceType==1" @click="download(listItem.id)">下 载</button>
            </h2>
            <div v-if="listItem.type ==1" class="img_wrap">
              <div :style="{transform:'scale('+multiples+')',transformOrigin:'top left'}">
                <viewer :images="[listItem.newAttaUrl]">
                  <img v-for="(src,i) in [listItem.newAttaUrl]" :src="src" :key="i">
                </viewer>
              </div>
            </div>
            <div :class="'pdf_wrap '+pdfEnlargStyle+' '+pageStyle" v-if="listItem.type ==2" @dblclick="pdfdblclick">
              <pdf
                style="width: 99%;margin:auto;"
                ref="pdf"
                :src="listItem.newAttaUrl"
                :page="pageNum"
                :rotate="pageRotate"
                @progress="loadedRatio = $event"
                @num-pages="pageTotalNum=$event"
                @link-clicked="page = $event"
                @loaded="loadPdfHandler"
              >
              </pdf>
              <i class="el-icon-arrow-left btn-def btn-pre" @dblclick.stop="" @click.stop="prePage"></i>
              <i class="el-icon-arrow-right btn-def btn-next" @dblclick.stop="" @click.stop="nextPage"></i>
              <span class="pdfCurrentPage">{{pageNum}}/{{pageTotalNum}}</span>
              <div class="operating_btn">
                <div>
                  <i class="el-icon-refresh-left" @click="counterClock" @dblclick.stop=""></i>
                  <i class="el-icon-refresh-right" @click="clock" @dblclick.stop=""></i>
                </div>
              </div>
            </div>
            <audio
              :src="listItem.newAttaUrl"
              controls="controls"
              v-if="listItem.type ==3"
              ref="audioC"
            ></audio>
            <video
              v-if="listItem.type ==4"
              id="video1"
              class="video-js"
              controls
              controlsList="nodownload"
              preload="auto"
              width="90%"
              :style="'height:'+videoHeight"
              data-setup='{"example_option":true}'
              ref="videoC"
              style="margin:auto"
            >
              <source
                id="sourceBox"
                :src="listItem.newAttaUrl"
                type="video/mp4"
              />
              <p class="vjs-no-js">不支持播放</p>
            </video>
            <div v-if="listItem.type == 5" class="zip_wrap">
              <iframe
                width="100%"
                height="100%"
                :src="listItem.newAttaUrl"
                frameborder="0"
                v-if="isZip"
              ></iframe>
              <div v-if="!isZip&&listItem.downloadFlag==1">
                <p>请点击“下载”，下载 “{{listItem.name}}” 到本地。</p>
              </div>
            </div>
            <div v-if="listItem.resourceType ==3" class="zip_wrap  editorShowArea ql-editor" v-html="listItem.content"></div>
            <div v-if="listItem.resourceType == 5" class="test_wrap">
              <ul>
                <li v-for="(item,key) in listItem.testPaper.sections" :key="key">
                  <h3>{{item.sectionName}}</h3>
                  <p>{{item.sectionScore}}分 / {{item.questionCount}}题</p>
                  <img v-if="item.sectionName=='单选题'" src="../../../../../../static/images/study/radio.png"/>
                  <img v-if="item.sectionName=='多选题'" src="../../../../../../static/images/study/checkbox.png"/>
                  <img v-if="item.sectionName=='判断题'" src="../../../../../../static/images/study/judge.png"/>
                  <img v-if="item.sectionName=='实操题'" src="../../../../../../static/images/study/operation.png"/>
                </li>
              </ul>
            </div>
          </div>
          <div v-show="!showMain" class="show_main_null">
            <img src="../../../../../../static/images/wujieguo.png" alt="">
            <p>本节无内容，请选择其他章节</p>
          </div>
        </div>
        <div v-if="swiperFlag" class="course_right">
          <mySwiper :sign="'preview'"></mySwiper>
        </div>
      </div>
      <div class="lock_box" v-else v-loading="!statusLoading">
        <img src="../../../../../../static/images/wujieguo.png"/>
        <p v-if="statusLoading">该章节暂未开放</p>
      </div>
    </div>
  </div>
  <div v-else class="task_list_preview">
    <div style="background: #fff;margin: 16px;padding: 16px;box-sizing:border-box;height: calc(100% - 32px)">
      <div class="cc_title">
        <div class="cc_search">
          <el-form :model="ruleForm" status-icon ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="name">
              <el-input type="text" v-model="ruleForm.name" autocomplete="off" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            <el-form-item prop="taskType" class="taskType">
              <el-select v-model="ruleForm.taskType" placeholder="请选择任务类型" clearable>
                <el-option
                  v-for="item in taskTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="company" class="company">
              <el-select v-model="ruleForm.company" placeholder="请选择所属公司" clearable>
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="search_btn">
              <el-button type="primary" @click="getTaskList">查询</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="cc_content" :style="'height:'+(windowHeight-215)+'px'">
        <div class="source_table_title">
          <p>序号</p>
          <p>任务名称</p>
          <p>任务类型</p>
          <p>所属公司</p>
          <p>创建时间</p>
          <p>推送时间</p>
          <p>操作</p>
        </div>
        <ul v-if="realTaskList.length>0">
          <li v-for="(item,key) in realTaskList" :data-key="item.id" :key="key">
            <div class="select_box">
              {{key+1}}
            </div>
            <div class="title_box">{{item.taskName}}</div>
            <div class="type_box">{{item.taskFlowName}}</div>
            <div class="company_box">{{item.companyName}}</div>
            <div class="createTime_box">{{item.createTime}}</div>
            <div class="pushTime_box">{{item.doTaskTime}}</div>
            <div class="operation_box"><span title="预览" class="preview_task" @click="previewTask(item)"></span></div>
          </li>
        </ul>
        <div v-else class="no_task">
          <img src="../../../../../../static/images/wujieguo.png" alt="">
          <p>暂无任务</p>
        </div>
      </div>
      <Pagination
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
        v-if="realTaskList.length"
      ></Pagination>
    </div>
    <el-drawer :visible.sync="previewTaskShow" :direction="direction" size="80%" :with-header="false" :close-on-press-escape="false" :modal-append-to-body="false">
      <div class="preview_task_wrap">
        <h2 class="preview_task_title">{{previewTaskData.title}}</h2>
        <div class="preview_task_content  editorShowArea ql-editor" v-html="previewTaskData.content" :style="'height:'+(windowHeight-60)+'px'"></div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
import {moduleId} from "../../../../../store/modules/courseDetail";
import './preview.scss'
import * as api from '../../../../../api/courseApi'
import axios from 'axios'
import qs from 'qs'
import miniSwiper from "../../../../subcomponent/miniSwiper/miniSwiper";
import mySwiper from "../../../../subcomponent/swiper/index";
import Pagination from "../../../../paginator/paginator";
export default {
  components: {
    pdf,miniSwiper,mySwiper,Pagination
  },
  data() {
    return {
      menuFlag: true,
      show: false,
      isShowAside: false,
      isShowCenter: true,
      dialogVisible: false,
      showMain:true,
      swiperData: [], //课程目录下资源列表
      data: [], //课程目录列表
      listItem: null, //显示详细课程内容 1,图片，2.文档，3，音频，4.视频
      expendId:[],//树节点默认展开
      resourceId:null,//上次学习记录的资源id
      selectData: null,//左侧目录选中数据
      postDirectory:{
        catalogId:null,//当前学习的目录id
        courseId:Number(this.$route.query.id),//课程id
        resourceId:null,//当前学习的资源id
        classId:Number(this.$route.query.classId),
        isEnd:0,// 0 未看完，1，已看完 。资源是否看完
        seatno:1,//资源学习次数
        resProgress:1,//这条资源最后一次学习的时间
        totalResNum:0//总资源数
      },
      progress:1,//资源进度
      pageNum:1,//pdf上一页
      pageTotalNum:1,//pdf下一页
      currentTime:0,//视频，音频当前播放进度
      defaultProps: {
        children: "children",
        label: "catalogName"
      },
      options: [],
      loading:true,
      multiples: 1,
      treeHeight: window.innerHeight - 180+'px',
      videoHeight: window.innerHeight - 250+'px',
      isZip: false,
      pdfEnlargStyle:'',
      pageStyle:'',
      pdfEnlargeSign:1,
      isFinish:'../../../../../../static/images/study/icon/unfinished.png',
      percentage: 0,//学习进度
      preview: 'preview',
      startTest:null,
      pageRotate:0,
      productFlag: sessionStorage.getItem('productFlag'),
      realTaskList: [],//任务列表
      taskTypeList: [],//任务流选项
      companyList: [],//公司选项
      ruleForm: {
        name: '',
        taskType: '',
        company: '',
      },
      pageTotal: {//分页
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      windowHeight: window.innerHeight,
      direction: 'rtl',
      previewTaskShow: false,//预览任务窗口
      previewTaskData: {
        title: '',
        content: ''
      },
      statusLoading: true
    };
  },
  mounted() {
    if(this.productFlag==4){
      this.getTaskList()
      this.getTaskFlow()
      this.getCompany()
    }else{
      //根据课程查询id查询目录接口
      api.getCourseCatalog(this.$route.query.id).then(rs => {
        this.loading=false;
        if (rs.code === "0") {
          this.data = rs.data;
          if(this.data && this.data.length>0){
            this.setCurrent(this.data[0].id);
            this.getResource(this.data[0].id);
            if(this.data[0].lockStatus==1){
              this.statusLoading = true;
            }else{
              this.statusLoading = false;
            }
          }
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(function(error) {
        console.log(error);
      });
    }
  },
  watch: {
    'swiperData':function (newValue) {
      this.setResourceList(newValue);
    },
    'currentResource':function (newValue) {
      this.getMsgFormSon(newValue);
    },
    'previewTaskShow': function(val){
      if(!val){
        this.previewTaskData = {
          title: '',
          content: ''
        }
      }
    }
  },
  computed:{
    ...mapState(moduleId, {
      swiperFlag:state => state.swiperFlag,
      currentResource:state => state.currentResource,
    }),
  },
  methods: {
    ...mapActions(moduleId, ['setResourceList','setResourceId']),
    download(id){
      let url = `${process.env.UPLOAD_NAME}/file/downloadFiles?id=`+id;
      this.$downloadFun(url)
    },
    toggleMenu() {
      this.menuFlag = !this.menuFlag;
    },
    toggleDialogSwiper() {
        this.dialogSwiper = !this.dialogSwiper;
    },
    handleNodeClick(data) {
      if(data.lockStatus==1){
        this.statusLoading = true
      }else{
        this.statusLoading = false
      }
      this.selectData = data;
      this.postDirectory.catalogId = data.id;
      this.loading=true;
      this.getResource(this.selectData.id);
    },
    getResource(id,resourceId) {//根据目录查询关联资源信息接口
      api.handleNodeClick(this.postDirectory.courseId,id).then(rs => {
        this.loading=false;
        if (rs.code === "0") {
          this.swiperData = rs.data;
          if(this.swiperData && this.swiperData.length>0){
            //默认显示第一个资源
            this.showMain = true;
            this.getMsgFormSon(this.swiperData[0]);
            this.setResourceId(this.swiperData[0].id);
          }else{
            this.showMain = false;
          }
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(function(error) {
        console.log(error);
      });
    },
    back() {
      this.show = false;
      this.isShowAside = false;
      this.isShowCenter = true;
      // this.dialogVisible = false;
      this.getResource(this.selectData.id);
    },
    getMsgFormSon(data) {
      this.isZip = false
      let {id} = data;
      let that = this;
      this.loading = false;
      this.listItem = data;
      this.pageNum = 1;
      this.pageRotate = 0;
      this.resourceId = id;
      //点击右侧资源记录学习进度
      if (data.type == 1) {
      } else if (data.type == 2) {
      } else if (data.type == 3) {
        that.$nextTick(()=>{
          that.$refs.audioC.load();
        })
      } else if (data.type == 4) {
        that.$nextTick(()=>{
          that.$refs.videoC.load();
        })
      }else if(data.type == 5){
        axios.post(`${process.env.UPLOAD_NAME}`+'/file/doesObjectExistZip',qs.stringify({filePath: data.newAttaUrl}),{
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: 'bearer '+localStorage.getItem('Authorization')
          },
        }).then(res => {
          if (res.data.code == 0) {
            this.isZip = true
          } else {
            this.isZip = false
          }
        }).catch(error => {
          console.log(error);
        })
      }
    },
    getResourceId(id){
      this.resourceId = id;
      this.postDirectory.resourceId = id;
      this.postDirectory.resProgress = 1;
    },
    setCurrent(id){//定位目录
      this.$nextTick(function(){
        this.$refs.vuetree.setCurrentKey(id);
      })
    },
    expendTree (id){//默认展开第几个目录
      this.expendId = [id];
    },
    //=======================真实任务============================
    getTaskList(){//获取任务列表
      let obj = {
        "catalogId": 0,
        "companyId": this.ruleForm.company,
        "courseId": this.$route.query.id,
        "pageNo": this.pageTotal.currentPage,
        "pageSize": this.pageTotal.pageSize,
        "param": this.ruleForm.name,
        "status": '1',
        "taskFlowType": this.ruleForm.taskType
      }
      api.getTaskList(obj).then(rs=>{
        if(rs.code==0){
          this.realTaskList = []
          if(rs.data.list && rs.data.list.length>0){
            rs.data.list.forEach(v=>{
              let obj = {
                catalogId: v.catalogId,
                companyId: v.companyId,
                companyName: v.companyName,
                courseId: v.courseId,
                createTime: v.createTime.substring(0,10),
                doTaskTime: v.doTaskTime?v.doTaskTime.substring(0,10):'--',
                id: v.id,
                questionContent: v.questionContent,
                resourceId: v.resourceId,
                status: v.status,
                taskFlowId: v.taskFlowId,
                taskFlowName: v.taskFlowName,
                taskName: v.taskName,
              }
              this.realTaskList.push(obj)
            })
          }else{
            this.realTaskList = []
          }
          this.pageTotal = {
            pageSize: rs.data.pageSize,
            total: rs.data.total
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getTaskFlow(){//获取任务流
      api.getTaskFlow(this.$route.query.subjectId).then(rs=>{
        if(rs.code==0){
          this.taskTypeList = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getCompany(){//获取公司
      let that = this
      let obj = {
        subjectId: this.$route.query.subjectId
      }
      api.queryCompany(obj).then(rs=>{
        if(rs.code==0){
          if(rs.data.length>0){
            let arr = []
            rs.data.forEach(v=>{
              if(v.lableIds.includes(4)){
                arr.push(v)
              }
              that.companyList = arr
            })
          }else{
            that.companyList = []
          }
        }else{
          that.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    previewTask(item){//预览任务
      this.previewTaskShow = true
      this.previewTaskData = {
        title: item.taskName,
        content: item.questionContent
      }
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      this.getTaskList()
    },
    handleSizeChange(val){
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.getTaskList()
    },
    //=======================pdf============================
    loadPdfHandler (e) {// pdf加载时
      this.pageNum = this.progress; // 加载的时候先加载第一页
    },
    prePage(e){
      let p = this.pageNum;
      p = p>1?p-1:this.pageTotalNum;
      this.pageNum = p;
      this.postDirectory.resProgress = this.pageNum;
      e.target.parentNode.scrollTo(0,0);
    },
    nextPage(e){
      let p = this.pageNum;
      p = p<this.pageTotalNum?p+1:1;
      this.pageNum = p;
      this.postDirectory.resProgress = this.pageNum;
      e.target.parentNode.scrollTo(0,0);
    },
    pdfdblclick(){
      if(this.pdfEnlargeSign==1){
        this.pdfEnlargeSign = 2
        this.pdfEnlargStyle="pdf_enlarge"
        this.pageStyle="page_style"
      }else{
        this.pdfEnlargeSign = 1
        this.pdfEnlargStyle=""
        this.pageStyle=""
      }
    },
    clock(){
      this.pageRotate += 90
    },
    counterClock(){
      this.pageRotate -= 90
    },
  },
};
</script>

<style lang="scss">
  #box {
    width: 100%;
    height: 100%;
    position: relative;
    /*滚动条样式*/
    *::-webkit-scrollbar{
      /*width: 18px!important;*/
      height: 15px!important;
    }
    #fram {
      position: absolute;
      top: 0;
      left: 0;
    }
    .el-dialog__wrapper{
      height: 100%;
      pointer-events: none;
      overflow: hidden;
      .el-dialog{
        position: relative;
        pointer-events: auto!important;
        overflow: hidden!important;
        .el-dialog__header {
          background-color: rgba(64,158,255,.1);
          border-radius: 8px 8px 0 0;
          height: 45px;
        }
        .el-dialog__title {
          display: block;
          font-size: 14px;
          height: 45px;
          color:rgba(51,51,51,1);
          padding-left: 5px;
          line-height: 45px;
        }
        .el-dialog__body{
          height: 100%;
          .font_size{
            font-size: 12px!important;
          }
          #lay {
            width: 100%;
            min-height: 400px;
            height: 100%;
            display: block;
            .aside {
              width: 100%;
              height: 100%;
              overflow: hidden;
              display: flex;
              .dialog_left {
                height: 100%;
                flex: 1;
                display: block;
                padding: 0 40px 0 10px;
                box-sizing: border-box;
                /*overflow: hidden;*/
                overflow: hidden;
                position: relative;
                .img_wrap {
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  overflow-y: auto;
                  display: block;
                }
                .pdf_wrap {
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  overflow-y: auto;
                  .btn-pre {
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    padding: 5px 5px;
                    margin: auto;
                    font-size: 16px;
                    width: 20px;
                    height: 20px;
                    background: rgba(0, 0, 0, 0.2);
                    text-align: center;
                    line-height: 20px;
                    border-radius: 50%;
                    cursor: pointer;
                    &:hover{
                      background: #5397F7;
                      color: white;
                    }
                  }

                  .btn-next {
                    position: absolute;
                    right: 50px;
                    top: 50%;
                    padding: 5px 5px;
                    margin: auto;
                    font-size: 16px;
                    width: 20px;
                    height: 20px;
                    background: rgba(0, 0, 0, 0.2);
                    text-align: center;
                    line-height: 20px;
                    border-radius: 50%;
                    cursor: pointer;
                    &:hover{
                      background: #5397F7;
                      color: white;
                    }
                  }

                  .pdfCurrentPage {
                    position: absolute;
                    right: 50%;
                    bottom:15px;
                  }
                }
                /*.zip_wrap{*/
                /*  width: 100%;*/
                /*  height: 90%;*/
                /*  overflow: hidden;*/
                /*  overflow-y: auto;*/
                /*  overflow-x: auto;*/
                /*  display: block;*/
                /*  image{*/
                /*    width: 100%;*/
                /*  }*/
                /*  .ql-editor{*/
                /*    height: 100%;*/
                /*  }*/
                /*}*/
                .menu-open {
                  background: url("../../img/close.png");
                  background-size: 100% 100%;
                }
              }
              .dialog_right {
                width: 28%;
                height: auto;
                display: block;
                padding-right: 10px;
              }
            }
          }
        }

        .dia_span{
          position: absolute;
          width: 515px;
          height: 35px;
          top:0;
          right: 0;
          padding-top: 10px;
          .el-radio-group{
            height: 24px;
            .el-radio-button__inner{
              padding:5px 10px;

            }
          }
          i{
            font-size: 20px;
            margin-left:20px;
            cursor: pointer;
          }
        }
      }
    }
    .course_content {
      width: 100%;
      height: 100%;
      background:rgba(244,244,244,1);
      display: flex;
      .course_left {
        height: calc(100% - 32px);
        width:264px;
        background:rgba(232,242,255,1);
        border-radius:0px 4px 0px 0px;
        margin-top: 16px;
        position: relative;
        .study_progress{
          width: 264px;
          height: 80px;
          background: url('../../../../../../static/images/study/tree_bg.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .study_progress_box{
            width: 60px;
            height: 60px;
            position: relative;
            .circle_progress{
              // width: 60px;
              // height: 60px;
              .el-progress-circle{
                width: 60px !important;
                height: 60px !important;
              }
            }
            .progress_text{
              width: 50px;
              height: 50px;
              background: #fff;
              font-size:16px;
              font-weight:400;
              color:rgba(83,151,247,1);
              text-align: center;
              position: absolute;
              left: 5px;
              top: 5px;
              line-height: 50px;
              border-radius: 50%;
            }
          }
          .study_task_statistics{
            margin-left: 16px;
            p{
              font-size:14px;
              font-weight:400;
              line-height:19px;
              color:rgba(83,151,247,1);
              &:first-child{
                span{
                  color:#DB3737;
                }
              }
            }
          }
        }
        .course_tree{
          width: 100%;
          margin-top: 10px;
          overflow: hidden;
          &:hover{
            overflow: auto;
          }
          .el-tree{
            overflow: hidden;
            background: none;
          }
          .span-ellipsis{
            // font-size:16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .is_finish{
            width: 12px;
            height: 12px;
            position: absolute;
            right: 16px;
          }
          .el-tree-node__children .span-ellipsis{
            font-size: 14px!important;
          }
          .el-tree-node__content{
            height: 36px;
            position: relative;
            font-size:14px;
            font-weight:400;
            color:rgba(102,102,102,1);
            .course_catalog_operation{
              display: none;
              i{
                margin-left: 3px;
                color: #5397F7;
              }
            }
          }
          .el-tree-node>.el-tree-node__children{
            overflow:inherit;
          }
          .el-tree-node.is-current > .el-tree-node__content {
            background:#fff;
            font-size:14px;
            font-weight:400;
            color:rgba(83,151,247,1);
          }
          .el-tree-node__content:hover{
            height: 36px;
            background: rgba(255,255,255,0.5);
          }
        }
        .el-tree-node__content>.el-tree-node__expand-icon{
          color:rgba(83,151,247,1);
        }
        .tree-icon{
          color:rgba(83,151,247,1);
        }
        .el-tree-node__expand-icon.is-leaf {
          color: transparent;
          cursor: default;
        }
      }
      .course_main {
        flex: 1;
        height: calc(100% - 32px);
        margin: 16px;
        overflow: hidden;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        box-sizing: border-box;
        .show_main {
          width: 100%;
          height: calc(100% - 32px);
          margin:auto;
          overflow: hidden;
          position: relative;
          .title{
            width: calc(100% - 96px);
            margin:15px 48px;
            padding-bottom:15px;
            padding-right: 100px;
            box-sizing: border-box;
            border-bottom: 1px solid #5397F7;
            span{
              display: block;
              width: 100%;
              font-size:14px;
              font-weight:bold;
              color:rgba(51,51,51,1);
              text-indent: 10px;
            }
            button{
              position: absolute;
              right: 48px;
              top: 15px;
              width:60px;
              height:24px;
              background:rgba(255,255,255,1);
              border:1px solid rgba(83,151,247,1);
              border-radius:4px;
              font-size:12px;
              font-weight:400;
              color:rgba(83,151,247,1);
              cursor: pointer;
              &:hover{
                color: #fff;
                background: #5397F7;
              }
            }
          }
          .img_wrap{
            width: 100%;
            height: calc(100% - 60px);
            overflow: hidden;
            overflow-y: auto;
            display: block;
            padding: 0 48px;
            box-sizing: border-box;
            img{
              max-width: 100%;
            }
            .operating_btn{
              position: absolute;
              width: 100%;
              bottom:0;
              div{
                margin:auto;
                width: 100px;
                i{
                  font-size: 20px;
                  color: #5397F7;
                  margin-left: 10px;
                  cursor: pointer;
                }
              }

            }
          }
          position: relative;
          .pdf_wrap{
            width: 100%;
            height: calc(100% - 60px);
            overflow: hidden;
            overflow-y: auto;
            display: block;
            padding: 0 48px;
            box-sizing: border-box;
            .btn-pre{
              position: absolute;
              left:10px;
              top:50%;
              padding: 5px 5px;
              margin: auto;
              font-size: 16px;
              width: 28px;
              height: 28px;
              background: rgba(0, 0, 0, 0.2);
              text-align: center;
              line-height: 28px;
              border-radius: 50%;
              cursor: pointer;
              &:hover{
                background: #5397F7;
                color: white;
              }
            }
            .btn-next{
              position: absolute;
              right:10px;
              top:50%;
              padding: 5px 5px;
              margin: auto;
              font-size: 16px;
              width: 28px;
              height: 28px;
              background: rgba(0, 0, 0, 0.2);
              text-align: center;
              line-height: 28px;
              border-radius: 50%;
              cursor: pointer;
              &:hover{
                background: #5397F7;
                color: white;
              }
            }
            .pdfCurrentPage{
              position: absolute;
              right:50%;
              bottom:15px;
            }
            .operating_btn{
              position: absolute;
              bottom: 2px;
              right:10px;
              display: flex;
              align-items: center;
              i{
                margin-left: 10px;
                text-align: center;
                font-size: 28px;
                color:#5397F7;
                cursor: pointer;
              }
              span{
                border: 1px solid #ccc;
                background: #ccc;
              }
            }

          }
          .zip_wrap{
            width: 100%;
            height: calc(100% - 60px);
            overflow: auto;
            display: block;
            padding: 0 48px;
            box-sizing: border-box;
            // button{
            //   position: absolute;
            //   bottom:0;
            //   left: 45%;
            //   opacity: 0.5;
            //   &:hover{
            //     opacity: 1!important;
            //   }
            // }
          }
          audio{
            margin-left: 48px;
          }
          .test_wrap{
            ul{
              width: 100%;
              margin-top: 10%;
              display: flex;
              justify-content: space-around;
              li{
                width:220px;
                height:160px;
                border-radius:16px;
                position: relative;
                &:nth-child(1){background:#5397F7}
                &:nth-child(2){background:#34D3B0}
                &:nth-child(3){background:#FF9E70}
                &:nth-child(4){background:#3CBFFF}
                &:nth-child(5){background:#3CBFFF}
                &:nth-child(6){background:#3CBFFF}
                h3{
                  font-size:24px;
                  font-weight:400;
                  color:rgba(255,255,255,1);
                  position: absolute;
                  left: 32px;
                  top: 36px;
                  max-height: 48px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  line-height: 32px;
                }
                p{
                  font-size:16px;
                  font-weight:400;
                  color:rgba(255,255,255,1);
                  position: absolute;
                  left: 32px;
                  bottom: 48px;
                }
                img{
                  width: 102px;
                  position: absolute;
                  right: 14px;
                  bottom: 14px;
                }
              }
            }
            .startPractice{
              width:140px;
              height:40px;
              line-height: 40px;
              text-align: center;
              background:rgba(83,151,247,1);
              opacity:1;
              border-radius:4px;
              font-size:14px;
              color:rgba(255,255,255,1);
              margin:100px auto 0;
              cursor: pointer;
            }
          }
        }
        .show_main_null{
          text-align: center;
          img{
            width: 280px;
            margin-top: 80px;
          }
          P{
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-top: 10px;
          }
        }
        .ql-editor{
          font-size: 14px;
        }
      }
      .course_right {
        width:216px;
        height: calc(100% - 32px);
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        margin-top: 16px;
        margin-right: 16px;
        .course_swiper {
          width: 200px;
          height: 680px;
          /*overflow: hidden;*/
        }
        .swiper-toggle {
          position: absolute;
          top: 50%;
          left: -16px;
          width: 20px;
          height: 64px;
          margin-top: -32px;
          cursor: pointer;
          background: url("../../img/open.png");
          background-size: 100% 100%;
        }
        .swiper-open {
          background: url("../../img/close.png");
          background-size: 100% 100%;
        }
      }
      .menu-toggle {
        position: fixed;
        top: 50%;
        left: 264px;
        width: 16px;
        height: 64px;
        margin-top: -32px;
        cursor: pointer;
        background: url("../../img/close.png");
        background-size: 100% 100%;
      }
      .menu-open {
        left: 0;
        background: url("../../img/close_right.png");
        background-size: 100% 100%;
      }
      .course_main_wrap{
        width: calc(100% - 264px);
        height: 100%;
        display: flex;
      }
      .lock_box {
        margin: 16px;
        width: calc(100% - 32px);
        height:calc(100% - 32px);
        background: white;
        text-align: center;
        img{
          width: 280px;
          margin-top: 80px;
        }
        p{
          font-size:14px;
          font-weight:400;
          margin-top: 16px;
        }
      }
    }

    /deep/.el-dialog {
      .el-dialog__header {
        padding: 0 20px !important;
      }
      .el-dialog__body {
        padding: 0 20px !important;
      }
      .dia_content {
        width: 100%;
        overflow: hidden;
        display: flex;
        .dia_left {
          height: 100%;
          width: 70%;
          text-align: center;
        }
        .dia_right {
          height: 560px;
          float: left;
          overflow: hidden;
        }
      }
    }
    .el-dialog__wrapper {
      position: inherit;
    }
  }
  .task_list_preview{
    width: 100%;
    height: 100%;
    position: relative;
    background: #f4f4f4;
    .cc_title{
      width: 100%;
      position: relative;
      display: flex;
      height: 50px;
      .cc_search{
        flex: 1;
        height: 50px;
        .el-form{
          height: 50px;
          display: flex;
          align-items: center;
          .el-form-item{
            display: flex;
            margin-right: 10px;
            margin-bottom: 0;
            .el-form-item__label{
              line-height: 32px;
            }
            .el-form-item__content{
              line-height: 32px;
              .el-input{
                .el-input__inner{
                  height: 32px;
                  line-height: 32px;
                }
                .el-input__icon{
                  line-height: 32px;
                }
              }
              .el-select{
                .el-input{
                  width: 150px;
                }
              }
            }
          }
        }
        .search_btn{
          button{
            padding: 0;
            height: 32px;
            width: 60px;
            margin-left: 10px;
            border: none;
          }
        }
      }
    }
    .cc_content{
      width:100%;
      margin: 0;
      overflow-y:auto;
      .el-checkbox-group{
        font-size: inherit
      }
      .source_table_title{
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: space-between;
        p{
          font-size:12px;
          color:rgba(93,100,110,1);
          text-align: center;
          &:nth-child(1){ width: 55px; }
          &:nth-child(2){ flex: 1; text-align: left; padding: 0 16px; box-sizing: border-box; }
          &:nth-child(3){ width: 150px; text-align: left; padding: 0 10px; box-sizing: border-box; }
          &:nth-child(4){ width: 20%; text-align: left; padding: 0 10px; box-sizing: border-box; }
          &:nth-child(5){ width: 10%; }
          &:nth-child(6){ width: 10%; }
          &:nth-child(7){ width: 10%; }
        }
      }
      ul{
        li{
          width:100%;
          min-height:40px;
          background:rgba(246,248,251,1);
          border-radius:4px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          font-size:12px;
          color:rgba(13,20,30,1);
          .select_box{
            .el-checkbox{
              display: inline-block;
            }
            .el-checkbox__label{
              display: none;
            }
          }
          .operation_box{
            display: flex;
            align-items: center;
            justify-content: center;
            span{
              margin-right: 16px;
              cursor: pointer;
              &:last-child{
                margin-right: 0;
              }
            }
            .preview_task{
              width: 14px;
              height: 14px;
              background: url('../../../../../../static/images/course/editSourceIcon/preview.png');
              background-size: 100% 100%;
              &:hover{
                background: url('../../../../../../static/images/course/editSourceIcon/preview-hv.png');
                background-size: 100% 100%;
              }
            }
          }
          div{
            text-align: center;
            word-break: break-all;
            &:nth-child(1){ width: 55px; }
            &:nth-child(2){ flex: 1; text-align: left; padding: 0 16px; box-sizing: border-box; }
            &:nth-child(3){ width: 150px; text-align: left; padding: 0 10px; box-sizing: border-box; }
            &:nth-child(4){ width: 20%; text-align: left; padding: 0 10px; box-sizing: border-box; }
            &:nth-child(5){ width: 10%; }
            &:nth-child(6){ width: 10%; }
            &:nth-child(7){ width: 10%; }
          }
        }
      }
      .no_task{
        text-align: center;
        img{
          margin-top: 10%;
          margin-bottom: 10px;
        }
      }
    }
    .preview_task_wrap{
      .preview_task_title{
        font-size:16px;
        font-weight:bold;
        line-height:60px;
        color:rgba(13,20,30,1);
        letter-spacing:1px;
        padding-left: 23px;
        border-bottom: 1px solid #DDE0E2;
      }
      .preview_task_content{
        padding: 16px;
        box-sizing: border-box;
        overflow: auto;
        word-break: break-word;
        img{
          max-width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/courseware/preview.vue